<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form [formGroup]="parkLotForm" (ngSubmit)="updateParkLot()" class="parking-lot-settings">
    <div class="page-content" onsip-grid-placement-shelf>
      <div class="first-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.PARKING_LOT_NAME" | translate }}</div>
          <mat-form-field appearance="outline">
            <input
              matInput
              required
              formControlName="name"
              autocomplete="off"
              [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_NAME"
            />
            <mat-error>{{
              getGenericNameError(parkLotForm.controls.name, "ONSIP_I18N.NAME" | translate)
            }}</mat-error>
          </mat-form-field>
        </section>
        <section class="with-mat-form-field with-field-grid">
          <div class="mat-body-1 title-with-field-grid m-b-12">
            {{ "ONSIP_I18N.PARKING_LOT_NUMBER_OF_CHANNELS" | translate }}
          </div>
          <div class="field-grid-block">
            <div class="filed-grid channels">
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="channelLimit"
                  [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_CHANNEL_LIMIT_SELECT"
                >
                  @for (count of numberOfChannels; track count) {
                  <mat-option [value]="count">
                    {{ count }}
                  </mat-option>
                  }
                </mat-select>
                <mat-error>{{
                  getGenericRequiredError(parkLotForm.controls.channelLimit, "Field")
                }}</mat-error>
              </mat-form-field>
              <span class="price mat-body-1"> {{ currentPrice | currency }}</span>
            </div>
          </div>
        </section>
        <section class="with-mat-form-field with-field-grid">
          <div class="mat-body-1 title-with-field-grid m-b-12">
            {{ "ONSIP_I18N.PARKING_LOT_RETRIEVAL_PIN" | translate }}
          </div>
          <div class="field-grid-block">
            <div class="filed-grid">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  formControlName="pin"
                  autocomplete="off"
                  [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_PIN"
                />
              </mat-form-field>
            </div>
          </div>
        </section>
      </div>
      <div class="second-column">
        <h3>{{ "ONSIP_I18N.PARKING_LOT_DESTINATION" | translate }}</h3>
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.SIP_ADDRESS" | translate }}</div>
          <onsip-sip-address-field #parkSipAddress formControlName="parkSipAddress">
          </onsip-sip-address-field>
        </section>
        <section class="m-b-28">
          <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
          <onsip-extensions-list
            #extensionsList
            formControlName="extensions"
            [currentId]="parkLot.address.addressId"
          >
          </onsip-extensions-list>
        </section>
      </div>
      <div class="third-column">
        <h3>{{ "ONSIP_I18N.PARKING_LOT_RETRIEVAL_DESTINATION" | translate }}</h3>
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">
            {{ "ONSIP_I18N.PARKING_LOT_RETRIEVAL_ADDRESS" | translate }}
          </div>
          <onsip-sip-address-field #retrieverSipAddressField formControlName="retrieveSipAddress">
          </onsip-sip-address-field>
        </section>
        <section class="m-b-28">
          <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
          <onsip-extensions-list
            #retrieverExtensionsList
            formControlName="retrieverExtensions"
            [currentId]="parkLot.retrieverAddress.addressId"
          >
          </onsip-extensions-list>
        </section>
      </div>
    </div>
    <div class="page-view-controls">
      <button mat-button color="primary" class="cancel" type="button" (click)="cancel()">
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
      <button
        type="submit"
        mat-flat-button
        color="primary"
        [attr.data-cy]="E2eLocators.ADMIN_PARKING_LOT_SAVE_CHANGES_BUTTON"
      >
        {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
      </button>
    </div>
  </form>
</onsip-loading-container>
